import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from "gatsby";
import LocaleContext from '../../LocaleContext';

// components
import CloseIcon from '../../icons/CloseIcon';
import ContactIframe from './ContactIframe';
import SlideIn from '../SlideIn/SlideIn';
import Loader from './Loader';

// styles
import './forms.scss';

const defaultState = {
  showForm: false,
  isLoading: true,
  showHeading: true,
  yOffset: 0
}

const ContactForm = ({ iframe, contactPerson, label }) => {
  const {locale} = useContext(LocaleContext);
  const [state, setState] = useState(defaultState)
  
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  })

  
  const handleScroll = () => (
    setState({
      ...state,
      yOffset: window.pageYOffset
    })
  )
  const toggleForm = (e) => {
    if (e === 27) return setState({...state, showForm: false})
    
    setState({
      ...state, 
      showForm: !state.showForm,
      isLoading: true,
      showHeading: true
    })
    
  }
  const hideFormHeading = () => {
    setState({
    ...state,
    showHeading: false,
    isLoading: true
    })
  }
  
  const _iframeLoaded = () => {
    setState({
      ...state,
      isLoading: false
    })
  }
  

  return (<StaticQuery query={graphql`
      query ContactFormMicrocopyQuery {
        allContentfulMicrocopyPages {
          nodes {
            language
            ttileContactForm
            subtitleContactForm
          }
        }
      }
    `} render={data => {
      const microcopyPage = data.allContentfulMicrocopyPages.nodes.filter(page => page?.language === locale)[0];
      const { ttileContactForm, subtitleContactForm } = microcopyPage;

      return (
        <div className="form-wrapper">
        <SlideIn
          in={state.showForm}
          close={(e) => toggleForm(e)}
          className={'contact-form'}
        >
          <div className={`contact-form-wrapper`}>
            {state.showForm && (
              <button className="close-form-btn" onClick={(e) => toggleForm(e)}>
                <CloseIcon />
              </button>
            )}
            {state.showHeading &&
              !state.isLoading && (
                <h2 className="form-heading">
              {ttileContactForm}
              <span className="italic">
                {subtitleContactForm}
              </span>
                </h2>
              )}
            {state.isLoading ? (
              <Loader/>
            ) : null}
            {state.showForm && (
              <ContactIframe
                onLoad={() => _iframeLoaded()}
                src={iframe}
                hideHeading={() => hideFormHeading()}
              />
            )}
          </div>
        </SlideIn>
        <div className={`open-form ${!state.showForm && 'show'}`}>
          <label className={`btn-label ${state.yOffset <= 0 && 'show'}`}>
            {label}
          </label>
          <button className="open-form-btn" onClick={(e) => toggleForm(e)}>
            <img
              src={contactPerson.file.url + '?w=100&h=100&f=face&fit=thumb'}
              alt={contactPerson.file.fileName}
            />
          </button>
        </div>
      </div>
    )}} />
  )
}

export default ContactForm;

ContactForm.defaultProps = {
  contactPerson: {},
  iframe: "https://www2.cloudnine.se/l/127451/2018-10-21/3m8714"
};

ContactForm.propTypes = {
  contactPerson: PropTypes.object,
  iframe: PropTypes.string
};
